import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, mixins } from "@similarweb/styles";
import { CenteredFlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";
import { contentWrapperBaseStyles } from "../../styles";

export const StyledImage = styled(SWReactIcons)`
    width: 155px;
`;

export const StyledTitle = styled.h3`
    ${mixins.setFontVariant("subtitle1", colorsPalettes.carbon["500"])};

    margin: 0;
    line-height: 20px;
`;

export const StyledSubTitle = styled.p`
    ${mixins.setFontVariant("caption", colorsPalettes.carbon["300"])};

    margin: 0;
    line-height: 20px;
`;

export const StyledView = styled(CenteredFlexColumn)`
    ${contentWrapperBaseStyles};

    row-gap: 16px;
    padding: 44px 24px;
`;
